module.exports = __webpack_public_path__ + "static/gold-dragon-aerosclughpalar-2150fd38879a9f7cda5c6d157de165f6.jpg";